import { useEffect, useState } from "react";

const BARS = 10, ROWS = 5;
const SHAPE = [0.75, 1, 0.9, 1, 0.85, 0.7, 0.85, 1, 0.75, 0.55];
const STILL = [3, 5, 4, 5, 4, 3, 4, 5, 3, 2];
const cellStyle = (on, c) => {
  const rgb = c < 1 ? "239 68 68" : c < 3 ? "156 163 175" : "255 255 255";
  return { backgroundColor: `rgb(${rgb} / ${on ? 1 : 0.1})`, boxShadow: on ? `0 0 4px rgb(${rgb} / 0.9)` : "none" };
};

// Fake speech: syllable bursts with short pauses between phrases, so the bars look like someone talking.
function useSpeechLevels(seed) {
  const [levels, setLevels] = useState(STILL);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let t = seed * 7, pauseLeft = 0, phraseLeft = 20 + seed * 5;
    const iv = setInterval(() => {
      t += 1;
      if (pauseLeft > 0) {
        pauseLeft -= 1;
        setLevels(Array.from({ length: BARS }, () => (Math.random() < 0.3 ? 1 : 0)));
        return;
      }
      if (--phraseLeft <= 0) { pauseLeft = 4 + Math.floor(Math.random() * 8); phraseLeft = 14 + Math.floor(Math.random() * 22); }
      const syllable = 0.25 + 0.75 * Math.abs(Math.sin(t * 0.9 + Math.sin(t * 0.37) * 2));
      setLevels(SHAPE.map((s) => Math.max(1, Math.min(ROWS, Math.round(ROWS * s * syllable * (0.5 + Math.random() * 0.8))))));
    }, 160);
    return () => clearInterval(iv);
  }, [seed]);
  return levels;
}

// Voice-bars box for the homepage mock-ups, animated like a live reaction.
export function MockVoiceBars({ seed = 0 }) {
  const levels = useSpeechLevels(seed);
  return (
    <div className="absolute top-[4%] right-[2.5%] w-[18%] aspect-square rounded-md overflow-hidden border-2 border-yellow-400 shadow-2xl bg-black" style={{ containerType: "inline-size" }} data-testid="mock-voice-bars">
      <div className="absolute left-[12%] right-[12%] top-[7%] bottom-[38%] flex gap-[3%]" style={{ WebkitBoxReflect: "below 2px linear-gradient(transparent 55%, rgba(255,255,255,0.35))" }}>
        {levels.map((n, i) => (
          <div key={i} className="flex-1 h-full flex flex-col-reverse gap-[6%]">
            {Array.from({ length: ROWS }).map((_, c) => (
              <div key={c} className="flex-1 rounded-[1px] transition-[background-color,box-shadow] duration-150" style={cellStyle(c < n, c)} />
            ))}
          </div>
        ))}
      </div>
      <div className="absolute inset-x-0 bottom-[7%] text-center text-white font-display font-normal leading-none whitespace-nowrap flex items-center justify-center gap-[0.5em]" style={{ fontSize: "6.5cqw" }}>
        <span className="w-[1.1em] h-[1.1em] rounded-full bg-white rec-pulse relative top-[0.2em]" /> Reaction
      </div>
    </div>
  );
}
